<div id="renewal-popup">
  <button type="button"
    class="close-btn"
    (click)="closeDialog()"></button>
  <!-- 구독형 스타터팩 -->
  <app-solution-subscribe *ngIf="type === 'subscribe'"></app-solution-subscribe>
  <!-- 소유형 스타터팩 -->
  <app-solution-ownership *ngIf="type === 'ownership'"></app-solution-ownership>
</div>
